import React from "react";
import { Navigate } from "react-router-dom";

/** Data files */
import { securityKey } from "../../utils/ENUMS/SecurityKey";
import Acquisitions from "../../pages/acquisitions/Acquisitions";
import Loaners from "../../pages/dashboard/features/loaners/Loaners";
import ReportsAndExtracts from "../../pages/reportsAndExtracts/ReportsAndExtracts";
import Tools from "../../pages/tools/Tools";
import Quality from "../../pages/quality/Quality";

import DraftInvoices from "../../pages/financial/features/draftInvoices/DraftInvoices";
import ClientsOnHold from "../../pages/financial/features/clientsOnHold/ClientsOnHold";
import Payments from "../../pages/financial/features/payments/Payments";
import WorkOrdersOnHold from "../../pages/financial/features/workOrdersOnHold/WorkOrdersOnHold";
import GPIntegration from "../../pages/financial/features/gPIntegration/GPIntegration";
import Profitability from "../../pages/financial/features/profitability/Profitability";
import RevenueAndExpenseDistribution from "../../pages/financial/features/revenueAndExpenseDistribution/RevenueAndExpenseDistribution";
import GLAccounts from "../../pages/financial/features/gLAccounts/GLAccounts";

//dynamic child routing
import RedirectToFirstPermittedChild from "../../lib/redirectToFirstPermittedChild";
import OutstandingInvoices from "../../pages/financial/features/outstandingInvoices/OutstandingInvoices";
import ManageAcquisitionsSupplierPO from "../../pages/acquisitions/features/Acquisitions Supplier PO/ManageAcquisitionsSupplierPO";
import ReceiveReturnAcquisitions from "../../pages/acquisitions/features/ReceiveReturn Acquisitions/ReceiveReturnAcquisitions";
import ContractMaintenance from "../../pages/contracts/features/contract Maintenance/ContractMaintenance";
import Contractlist from "../../pages/contracts/features/Contractlist";
import ContractReports from "../../pages/contracts/features/contractReports/ContractReports";
import ModelContractCosts from "../../pages/contracts/features/modelContractCosts/ModelContractCosts";
import PendingContracts from "../../pages/contracts/features/pendingContracts/PendingContracts";
import EditPendingContract from "../../pages/contracts/features/pendingContracts/EditPendingContract";
import Invoices from "../../pages/contracts/features/Invoices/Invoices";
import OnsiteServices from "../../pages/onsiteServices/OnsiteServices";
import ProductSale from "../../pages/productSale/ProductSale";

const CollapsibleGrid = React.lazy(() => import("../../pages/testPage/CollapsibleGrid"));
const FinalMolGridPage = React.lazy(() => import("../../pages/testPage/FinalMolGridPage"));

const NotFound = React.lazy(() => import("../../pages/errors/NotFound"));
const WorkSpace = React.lazy(() => import("../../pages/workspace/MyWorkspace"));
const Departments = React.lazy(() => import("../../pages/departments/Departments"));
const Repairs = React.lazy(() => import("../../pages/repairs/Repairs"));

// Dashboard
const Dashboard = React.lazy(() => import("../../pages/dashboard/Dashboard"));
const DashboardScopes = React.lazy(() => import("../../pages/dashboard/features/scopes/Scopes"));
const DashboardTasks = React.lazy(() => import("../../pages/dashboard/features/tasks/Tasks"));
const DashboardLoaners = React.lazy(() => import("../../pages/dashboard/features/loaners/Loaners"));
const DashboardEmails = React.lazy(() => import("../../pages/dashboard/features/emails/Emails"));
const DashboardShippingStatus = React.lazy(() => import("../../pages/dashboard/features/shippingStatus/ShippingStatus"));
const DashboardInventory = React.lazy(() => import("../../pages/dashboard/features/inventory/Inventory"));
const DashboardAcquisition = React.lazy(() => import("../../pages/dashboard/features/acquisitions/Acquisition"));
const DashboardSearches = React.lazy(() => import("../../pages/dashboard/features/searches/Searches"));
const DashboardRepairMetrics = React.lazy(() => import("../../pages/dashboard/features/repairMetrics/RepairMetrics"));
const DashboardTurnAroundTimes = React.lazy(() => import("../../pages/dashboard/features/turnAroundTimes/TurnAroundTimes"));
const DashboardFlags = React.lazy(() => import("../../pages/dashboard/features/flags/Flags"));
const DevelopmentList = React.lazy(() => import("../../pages/developmentList/DevelopmentList"));

// Clients
const Clients = React.lazy(() => import("../../pages/clients/Clients"));

// Change Password
const ChangePassword = React.lazy(() => import("../../pages/changePassword/ChangePassword"));

// Scopes
const Scopes = React.lazy(() => import("../../pages/scopes/Scopes"));

// Inventory
const ManageInventory = React.lazy(() => import("../../pages/inventory/features/inventory/ManageInventory"));
const ManagePurchaseOrders = React.lazy(() => import("../../pages/inventory/features/purchaseOrders/ManagePurchaseOrder"));
const ReceiveInventory = React.lazy(() => import("../../pages/inventory/features/purchaseOrders/features/receiveInventory/ReceiveInventory"))
const ManageAdjustments = React.lazy(() => import("../../pages/inventory/features/adjustments/ManageAdjustments"));

// Administration
const Security = React.lazy(() => import("../../pages/administration/features/security/Security"));
const Companies = React.lazy(() => import("../../pages/administration/features/companies/Companies"));
const Distributors = React.lazy(() => import("../../pages/administration/features/distribution/Distributors"));
const PricingLists = React.lazy(() => import("../../pages/administration/features/pricingList/PricingLists"));
const ReferenceTables = React.lazy(() => import("../../pages/administration/features/referenceTables/ReferenceTables"));
const ManageStaff = React.lazy(() => import("../../pages/administration/features/manageStaff/ManageStaff"));

// ScopeModel
const ScopeModel = React.lazy(() => import("../../pages/repairItems/scopeModel/ManageScopeModel"));

// Instruments
const Instruments = React.lazy(() => import("../../pages/repairItems/instruments/Instruments"));

// Repair Items
const RepairItems = React.lazy(() => import("../../pages/repairItems/repairItems/ManageRepairItems"));

// Suppliers
const ManageSuppliers = React.lazy(() => import("../../pages/suppliers/features/ManageSuppliers"));
const EditSuppliers = React.lazy(() => import("../../pages/suppliers/features/EditSuppliers"));

export const ComponentNavigation = [
  {
    id: "pageNotFound",
    path: "pageNotFound",
    exact: true,
    title: "",
    component: NotFound,
    text: "Page not found",
    securityKey: "",
  },
  {
    id: "homePage",
    path: "/",
    exact: true,
    title: "Home Page",
    component: WorkSpace,
    hasParams: false,
    text: "Home Page",
    securityKey: securityKey.MY_WORKSPACE,
  },
  {
    id: "dashboard",
    path: "/Dashboard",
    exact: false,
    title: "Dashboard",
    component: () => (
      <RedirectToFirstPermittedChild
        routes={ComponentNavigation.find(r => r.id === "dashboard")?.children || []}
      />
    ),
    hasParams: false,
    text: "Dashboard",
    securityKey: securityKey.DASHBOARD,
    children: [
      {
        id: "scopes",
        path: "/Dashboard/Scopes",
        exact: true,
        title: "Scopes",
        component: DashboardScopes,
        hasParams: false,
        text: "Scopes",
        securityKey: securityKey.DASHBOARD_SCOPES,
      },
      {
        id: "tasks",
        path: "/Dashboard/Tasks",
        exact: true,
        title: "Tasks",
        component: DashboardTasks,
        hasParams: false,
        text: "Tasks",
        securityKey: securityKey.DASHBOARD_TASKS,
      },
      {
        id: "loaners",
        path: "/Dashboard/Loaners",
        exact: true,
        title: "Loaners",
        component: DashboardLoaners,
        hasParams: false,
        text: "Loaners",
        securityKey: securityKey.DASHBOARD_LOANERS,
      },
      {
        id: "emails",
        path: "/Dashboard/Emails",
        exact: true,
        title: "Emails",
        component: DashboardEmails,
        hasParams: false,
        text: "Emails",
        securityKey: securityKey.DASHBOARD_EMAILS,
      },
      {
        id: "shoppingStatus",
        path: "/Dashboard/ShoppingStatus",
        exact: true,
        title: "Shopping Status",
        component: DashboardShippingStatus,
        hasParams: false,
        text: "Shopping Status",
        securityKey: securityKey.DASHBOARD_SHIPPING_STATUS,
      },
      {
        id: "inventory",
        path: "/Dashboard/Inventory",
        exact: true,
        title: "Inventory",
        component: DashboardInventory,
        hasParams: false,
        text: "Inventory",
        securityKey: securityKey.DASHBOARD_INVENTORY,
      },
      {
        id: "acquisitions",
        path: "/Dashboard/Acquisitions",
        exact: true,
        title: "Acquisitions",
        component: DashboardAcquisition,
        hasParams: false,
        text: "Acquisitions",
        securityKey: securityKey.DASHBOARD_ACQUISITIONS,
      },
      {
        id: "search",
        path: "/Dashboard/QuickSearches",
        exact: true,
        title: "Searches",
        component: DashboardSearches,
        hasParams: false,
        text: "Searches",
        securityKey: securityKey.DASHBOARD_SEARCHES,
      },
      {
        id: "repairMetrics",
        path: "/Dashboard/RepairMetrics",
        exact: true,
        title: "Repair Metrics",
        component: DashboardRepairMetrics,
        hasParams: false,
        text: "Repair Metrics",
        securityKey: securityKey.DASHBOARD_REPAIR_METRICS,
      },
      {
        id: "repairTimes",
        path: "/Dashboard/RepairTimes",
        exact: true,
        title: "Repair Times",
        component: Dashboard,
        hasParams: false,
        text: "Repair Times",
        securityKey: securityKey.DASHBOARD_REPAIR_TIMES,
      },
      {
        id: "repairItemCosts",
        path: "/Dashboard/RepairItemCosts",
        exact: true,
        title: "Repair Item Costs",
        component: Dashboard,
        hasParams: false,
        text: "Repair Item Costs",
        securityKey: securityKey.DASHBOARD_REPAIR_ITEM_COSTS,
      },
      {
        id: "turnAroundTimes",
        path: "/Dashboard/TurnAroundTimes",
        exact: true,
        title: "Turn Around Times",
        component: DashboardTurnAroundTimes,
        hasParams: false,
        text: "Turn Around Times",
        securityKey: securityKey.DASHBOARD_TURN_AROUND_TIMES,
      },
      {
        id: "flags",
        path: "/Dashboard/Flags",
        exact: true,
        title: "Flags",
        component: DashboardFlags,
        hasParams: false,
        text: "Flags",
        securityKey: securityKey.DASHBOARD_FLAGS,
      },
      {
        id: "revExp",
        path: "/Dashboard/RevExp",
        exact: true,
        title: "Rev/Exp Distribution",
        component: Dashboard,
        hasParams: false,
        text: "Rev/Exp Distribution",
        securityKey: securityKey.DASHBOARD_REV_EXP_DISTRIBUTION,
      },
      {
        id: "points",
        path: "/Dashboard/Points",
        exact: true,
        title: "Points",
        component: Dashboard,
        hasParams: false,
        text: "Points",
        securityKey: securityKey.DASHBOARD_POINTS,
      },
      {
        id: "techHours",
        path: "/Dashboard/TechHours",
        exact: true,
        title: "Tech Hours",
        component: Dashboard,
        hasParams: false,
        text: "Tech Hours",
        securityKey: securityKey.DASHBOARD_TECH_HOURS,
      },
      {
        id: "gpIntegration",
        path: "/Dashboard/GPIntegration",
        exact: true,
        title: "GP Integration",
        component: Dashboard,
        hasParams: false,
        text: "GP Integration",
        securityKey: securityKey.DASHBOARD_GP_INTEGRATION,
      },
      {
        id: "developmentList",
        path: "/Dashboard/DevelopmentList",
        exact: true,
        title: "Development List",
        component: Dashboard,
        hasParams: false,
        text: "Development List",
        securityKey: securityKey.DASHBOARD_DEVELOPMENT_LIST,
      },
      {
        id: "colorPalette",
        path: "/Dashboard/ColorPalette",
        exact: true,
        title: "Color Palette",
        component: Dashboard,
        hasParams: false,
        text: "Color Palette",
        securityKey: securityKey.DASHBOARD_COLOR_PALETTE,
      },
      {
        id: "points",
        path: "/Dashboard/Points",
        exact: true,
        title: "Points",
        component: Dashboard,
        hasParams: false,
        text: "Points",
        securityKey: securityKey.DASHBOARD_STEVE,
      },
    ],
  },
  {
    id: "administration",
    path: "/Administration",
    exact: true,
    title: "Administration",
    component: () => (
      <RedirectToFirstPermittedChild
        routes={ComponentNavigation.find(r => r.id === "administration")?.children || []}
      />
    ),
    hasParams: false,
    text: "Administration",
    securityKey: securityKey.ADMINISTRATION,
    children: [
      {
        id: "security",
        path: "/Administration/Security",
        exact: true,
        title: "Security",
        component: Security,
        hasParams: false,
        text: "Security",
        securityKey: securityKey.ADMINISTRATION_SECURITY,
      },
      {
        id: "companies",
        path: "/Administration/Companies",
        exact: true,
        title: "Companies",
        component: Companies,
        hasParams: false,
        text: "Companies",
        securityKey: securityKey.ADMINISTRATION_COMPANIES,
      },
      {
        id: "distributors",
        path: "/Administration/Distributors",
        exact: true,
        title: "Distributors",
        component: Distributors,
        hasParams: false,
        text: "Distributors",
        securityKey: securityKey.ADMINISTRATION_DISTRIBUTORS,
      },
      {
        id: "pricingLists",
        path: "/Administration/PricingLists",
        exact: true,
        title: "Pricing Lists",
        component: PricingLists,
        hasParams: false,
        text: "Pricing Lists",
        securityKey: securityKey.ADMINISTRATION_PRICING_LISTS,
      },
      {
        id: "referenceTables",
        path: "/Administration/ReferenceTables",
        exact: true,
        title: "Reference Tables",
        component: ReferenceTables,
        hasParams: false,
        text: "Reference Tables",
        securityKey: securityKey.ADMINISTRATION_REFERENCE_TABLES,
      },
      {
        id: "manageStaff",
        path: "/Administration/ManageStaff",
        exact: true,
        title: "Manage Staff",
        component: ManageStaff,
        hasParams: false,
        text: "Manage Staff",
        securityKey: securityKey.ADMINISTRATION_MANAGE_STAFF,
      },
    ],
  },
  {
    id: "MyWorkspace",
    path: "/MyWorkspace",
    exact: true,
    title: "My Workspace",
    component: WorkSpace,
    hasParams: false,
    text: "My Workspace",
    securityKey: securityKey.MY_WORKSPACE,
    children: [
      {
        id: "workspace",
        path: "/MyWorkspace/Projects",
        exact: true,
        title: "My Workspace",
        component: WorkSpace,
        hasParams: false,
        text: "Administration",
        securityKey: securityKey.MY_WORKSPACE,
      },
    ],
  },
  {
    id: "clients",
    path: "/Clients",
    exact: true,
    title: "Clients",
    component: Clients,
    hasParams: false,
    text: "Clients",
    securityKey: securityKey.CLIENTS,
  },
  {
    id: "scopes",
    path: "/Scopes",
    exact: true,
    title: "Scopes",
    // component: Departments,
    component: () => <Navigate to="/Scopes/Scopes" />,
    hasParams: false,
    text: "Scopes",
    securityKey: securityKey.SCOPES,
    children: [
      {
        id: "scopeTypes",
        path: "/Scopes/Scopes",
        exact: true,
        title: "Scope Types",
        component: Scopes,
        hasParams: false,
        text: "Scope Types",
        securityKey: securityKey.SCOPES_SCOPE_TYPES,
      },
      {
        id: "scopeTypes",
        path: "/Scopes/ScopeTypes",
        exact: true,
        title: "Scope Types",
        component: Departments,
        hasParams: false,
        text: "Scope Types",
        securityKey: securityKey.SCOPES_SCOPE_TYPES,
      },
    ],
  },
  {
    id: "repairItems",
    path: "/RepairItems",
    exact: true,
    title: "Repair Items",
    // component: () => <Navigate to="/RepairItems/RepairItems" />,
    component: RepairItems,
    hasParams: false,
    text: "Repair Items",
    securityKey: securityKey.REPAIR_ITEMS,
    redirect: "/RepairItems/RepairItems",
    children: [
      // {
      //   id: "repairItems",
      //   path: "/RepairItems",
      //   exact: true,
      //   title: "RepairItems",
      //   component: RepairItems,
      //   hasParams: false,
      //   text: "RepairItems",
      //   securityKey: securityKey.REPAIR_ITEMS_SUB,
      // },
      // {
      //   id: "instruments",
      //   path: "/Instruments",
      //   exact: true,
      //   title: "Instruments",
      //   component: Instruments,
      //   hasParams: false,
      //   text: "Instruments",
      //   securityKey: securityKey.REPAIR_ITEMS_INSTRUMENTS,
      // },
      // {
      //   id: "scopeModel",
      //   path: "/ScopeModel",
      //   exact: true,
      //   title: "Scope Model",
      //   // component: UnderCunstruction,
      //   component: ScopeModel,
      //   hasParams: false,
      //   text: "ScopeModel",
      //   securityKey: securityKey.REPAIR_ITEMS_INSTRUMENTS,
      // },
    ],
  },
  {
    id: "instruments",
    path: "/Instruments",
    exact: true,
    title: "Instruments",
    component: Instruments,
    hasParams: false,
    text: "Instruments",
    securityKey: securityKey.INSTRUMENTS,
  },
  {
    id: "scopeModel",
    path: "/ScopeModel",
    exact: true,
    title: "Scope Model",
    // component: UnderCunstruction,
    component: ScopeModel,
    hasParams: false,
    text: "ScopeModel",
    securityKey: securityKey.SCOPE_MODEL,
  },
  {
    id: "inventory",
    path: "/Inventory",
    exact: true,
    title: "Inventory",
    component: () => (
      <RedirectToFirstPermittedChild
        routes={ComponentNavigation.find(r => r.id === "inventory")?.children || []}
      />
    ),
    hasParams: false,
    text: "Inventory",
    securityKey: securityKey.INVENTORY,
    children: [
      {
        id: "inventory",
        path: "/Inventory/Inventory",
        exact: true,
        title: "Inventory",
        // component: NotFound,
        component: ManageInventory,
        hasParams: false,
        text: "Inventory",
        securityKey: securityKey.INVENTORY_SUB,
      },
      {
        id: "purchaseOrders",
        path: "/Inventory/PurchaseOrders",
        exact: true,
        title: "Purchase Orders",
        component: ManagePurchaseOrders,
        hasParams: false,
        text: "Purchase Orders",
        securityKey: securityKey.INVENTORY_PURCHASE_ORDERS,
      },

      {
        id: "receiveInventory",
        path: "/Inventory/ReceiveInventory",
        exact: true,
        title: "Receive Inventory",
        component: ReceiveInventory,
        hasParams: false,
        text: "Receive Inventory",
        securityKey: securityKey.INVENTORY_RECEIVEINVENTORY,
      },
      {
        id: "adjustments",
        path: "/Inventory/InventoryAdjustments",
        exact: true,
        title: "Inventory Adjusments",
        component: ManageAdjustments,
        hasParams: false,
        text: "Inventory Adjusments",
        securityKey: securityKey.INVENTORY_INVENTORY_ADJUSTMENTS,
      },
      {
        id: "lotNumbers",
        path: "/Inventory/LotNumberMaintenance",
        exact: true,
        title: "Lot Number Maintenance",
        component: NotFound,
        hasParams: false,
        text: "Lot Number Maintenance",
        securityKey: securityKey.INVENTORY_LOT_NUMBER_MAINTENANCE,
      },
      {
        id: "lonarScopes",
        path: "/Inventory/LonarScopes",
        exact: true,
        title: "Lonar Scopes",
        component: NotFound,
        hasParams: false,
        text: "Lonar Scopes",
        securityKey: securityKey.INVENTORY_LOANER_SCOPES,
      },

    ],
  },

  {
    id: "manageSuppliers",
    path: "/Suppliers",
    exact: true,
    title: "Suppliers",
    component: ManageSuppliers,
    hasParams: false,
    text: "Suppliers",
    securityKey: securityKey.SUPPLIERS,
  },

  {
    id: "editSuppliers",
    path: "/EditSuppliers",
    exact: true,
    title: "Edit Suppliers",
    component: EditSuppliers,
    hasParams: false,
    text: "Suppliers",
    securityKey: securityKey.SUPPLIERS,
  },

  {
    id: "acquisitions",
    path: "/Acquisitions",
    exact: true,
    title: "Acquisitions",
    component: () => (
      <RedirectToFirstPermittedChild
        routes={ComponentNavigation.find(r => r.id === "acquisitions")?.children || []}
      />
    ),
    hasParams: false,
    text: "Acquisitions",
    securityKey: securityKey.ACQUISITIONS,
    children: [
      {
        id: "acquisitionsSupplierPO",
        path: "/Acquisitions/SupplierPOs",
        exact: true,
        title: "Supplier POs",
        component: ManageAcquisitionsSupplierPO,
        hasParams: false,
        text: "Supplier POs",
        securityKey: securityKey.SUPPLIER_POS,
      },
      {
        id: "receiveReturn",
        path: "/Acquisitions/Receivereturn",
        exact: true,
        title: "Receive/Returns",
        component: ReceiveReturnAcquisitions,
        hasParams: false,
        text: "Receive/Returns",
        securityKey: securityKey.RECEIVE_RETURN_ACQUISITIONS,
      },
    ],
  },
  {
    id: "repairs",
    path: "/Repairs",
    exact: true,
    title: "Repairs",
    component: Repairs,
    hasParams: false,
    text: "Repairs",
    securityKey: securityKey.REPAIRS,
  },
  {
    id: "departments",
    path: "/Departments",
    exact: true,
    title: "Departments",
    component: Departments,
    hasParams: false,
    text: "Departments",
    securityKey: securityKey.DEPARTMENTS,
  },
  // {
  //   id: "Invoices",
  //   path: "/Invoices",
  //   exact: true,
  //   title: "Invoices",
  //   component: Invoices,
  //   hasParams: false,
  //   text: "Invoices",
  //   securityKey: securityKey.INVOICES,
  // },
  {
    id: "financial",
    path: "/Financial",
    exact: true,
    title: "Financial",
    //component: Financial,
    component: () => (
      <RedirectToFirstPermittedChild
        routes={ComponentNavigation.find(r => r.id === "financial")?.children || []}
      />
    ),
    hasParams: false,
    text: "Financial",
    securityKey: securityKey.FINACIAL,
    children: [
      {
        id: "outstandingInvoices",
        path: "/Financial/OutstandingInvoices",
        exact: true,
        title: "Out standing Invoices",
        component: OutstandingInvoices,
        hasParams: false,
        text: "Out standing Invoices",
        securityKey: securityKey.FINACIAL_OUTSTANDING_INVOICES,
      },
      {
        id: "draftInvoices",
        path: "/Financial/DraftInvoices",
        exact: true,
        title: "Draft Invoices",
        component: DraftInvoices,
        hasParams: false,
        text: "Draft Invoices",
        securityKey: securityKey.FINACIAL_DRAFT_INVOICES,
      },
      {
        id: "clientsOnHold",
        path: "/Financial/ClientsOnHold",
        exact: true,
        title: "Clients OnHold",
        component: ClientsOnHold,
        hasParams: false,
        text: "Clients OnHold",
        securityKey: securityKey.FINACIAL_CLIENTS_ONHOLD,
      },
      {
        id: "workOrdersOnHold",
        path: "/Financial/WorkOrdersOnHold",
        exact: true,
        title: "Work Orders OnHold",
        component: WorkOrdersOnHold,
        hasParams: false,
        text: "Work Orders OnHold",
        securityKey: securityKey.FINACIAL_WORKORDERS_ONHOLD,
      },

      {
        id: "payments",
        path: "/Financial/Payments",
        exact: true,
        title: "Payments",
        component: Payments,
        hasParams: false,
        text: "Payments",
        securityKey: securityKey.FINACIAL_PAYMENTS,
      },
      {
        id: "gpIntegration",
        path: "/Financial/GPIntegration",
        exact: true,
        title: "GPIntegration",
        component: GPIntegration,
        hasParams: false,
        text: "GPIntegration",
        securityKey: securityKey.FINACIAL_GPINTEGRATION,
      },
      {
        id: "profitability",
        path: "/Financial/Profitability",
        exact: true,
        title: "Profitability",
        component: Profitability,
        hasParams: false,
        text: "Profitability",
        securityKey: securityKey.FINACIAL_PROFITABILITY,
      },

      {
        id: "revenueAndExpenseDistribution",
        path: "/Financial/RevenueAndExpenseDistribution",
        exact: true,
        title: "Revenue And Expense Distribution",
        component: RevenueAndExpenseDistribution,
        hasParams: false,
        text: "Revenue And Expense Distribution",
        securityKey: securityKey.FINACIAL_REVENUE_AND_EXPENSE_DISTRIBUTION,
      },

      {
        id: "glAccounts",
        path: "/Financial/GLAccounts",
        exact: true,
        title: "GLAccounts",
        component: GLAccounts,
        hasParams: false,
        text: "GLAccounts",
        securityKey: securityKey.FINACIAL_GLACCOUNTS,
      },
    ]
  },
  {
    id: "Acquisitions",
    path: "/Acquisitions",
    exact: true,
    title: "Acquisitions",
    component: Acquisitions,
    hasParams: false,
    text: "Acquisitions",
    securityKey: securityKey.MY_WORKSPACE,
  },
  {
    id: "Contracts",
    path: "/Contracts",
    exact: true,
    title: "Contracts",
    component: () => (
      <RedirectToFirstPermittedChild
        routes={ComponentNavigation.find(r => r.id === "Contracts")?.children || []}
      />
    ),
    hasParams: false,
    text: "Contracts",
    securityKey: securityKey.CONTRACTS,
    children: [
      {
        id: "open",
        path: "/Contracts/Open",
        exact: true,
        title: "Open",
        component: Contractlist,
        hasParams: false,
        text: "Open",
        securityKey: securityKey.CONTRACTS_OPEN,
      },
      {
        id: "invoices",
        path: "/Contracts/Invoices",
        exact: true,
        title: "Invoices",
        component: Invoices,
        hasParams: false,
        text: "Invoices",
        securityKey: securityKey.CONTRACTS_INVOICES,
      },
      {
        id: "reports",
        path: "/Contracts/Reports",
        exact: true,
        title: "Reports",
        component: ContractReports,
        hasParams: false,
        text: "Reports",
        securityKey: securityKey.CONTRACTS_REPORTS,
      },
      {
        id: "modelContractCosts",
        path: "/Contracts/ModelContractCosts",
        exact: true,
        title: "Model Contract Costs",
        component: ModelContractCosts,
        hasParams: false,
        text: "ModelContractCosts",
        securityKey: securityKey.CONTRACTS_MODELCONTRACTCOSTS,
      },
      {
        id: "pendingcontracts",
        path: "/Contracts/PendingContracts",
        exact: true,
        title: "Pending Contracts",
        component: PendingContracts,
        hasParams: false,
        text: "Pending Contracts",
        securityKey: securityKey.CONTRACTS_PENDING,
      }
    ]
  },
  {
    id: "EditContracts",
    path: "/EditContracts",
    exact: true,
    title: "Contracts",
    component: ContractMaintenance,
    hasParams: true,
    text: "Contracts",
    securityKey: securityKey.CONTRACTS,
  },
  {
    id: "EditPendingContracts",
    path: "/EditPendingContracts",
    exact: true,
    title: "Pending Contracts",
    component: EditPendingContract,
    hasParams: true,
    text: "Edit Pending Contracts",
    securityKey: securityKey.CONTRACTS_PENDING,
  },

  {
    id: "Loaners",
    path: "/Loaners",
    exact: true,
    title: "Loaners",
    component: Loaners,
    hasParams: false,
    text: "Loaners",
    securityKey: securityKey.MY_WORKSPACE,
  },
  {
    id: "ReportsAndExtracts",
    path: "/Reports",
    exact: true,
    title: "ReportsAndExtracts",
    component: ReportsAndExtracts,
    hasParams: false,
    text: "ReportsAndExtracts",
    securityKey: securityKey.MY_WORKSPACE,
  },
  {
    id: "DevelopmentList",
    path: "/DevelopmentList",
    exact: true,
    title: "DevelopmentList",
    // component: Dummy,
    component: DevelopmentList,
    hasParams: false,
    text: "DevelopmentList",
    securityKey: securityKey.MY_WORKSPACE,
  },
  {
    id: "Tools",
    path: "/Administration/Tools",
    exact: true,
    title: "Tools",
    component: Tools,
    hasParams: false,
    text: "Tools",
    securityKey: securityKey.MY_WORKSPACE,
  },
  {
    id: "OnsiteServices",
    path: "/OnsiteServices",
    exact: true,
    title: "Onsite Services",
    component: OnsiteServices,
    hasParams: false,
    text: "Onsite Services",
    securityKey: securityKey.ONSITE_SERVICES,
  },
  {
    id: "ProductSale",
    path: "/ProductSale",
    exact: true,
    title: "Product Sale",
    component: ProductSale,
    hasParams: false,
    text: "Product Sale",
    securityKey: securityKey.PRODUCT_SALE,
  },
  {
    id: "Quality",
    path: "/Quality",
    exact: true,
    title: "Quality",
    component: Quality,
    hasParams: false,
    text: "Quality",
    securityKey: securityKey.MY_WORKSPACE,
  },
  {
    id: "ChangePassword",
    path: "/ChangePassword",
    exact: true,
    title: "ChangePassword",
    component: ChangePassword,
    // component: UnderCunstruction,
    hasParams: false,
    text: "ChangePassword",
    securityKey: securityKey.ADMINISTRATION,
  },

  // {
  //     id: 'ResetPassword',
  //     path: '/ResetPassword',
  //     exact: true,
  //     title: 'Reset Password',
  //     component: ResetPassword,
  //     hasParams: false,
  //     text: 'Reset Password',
  //     securityKey: '',
  // },

  {
    id: "CollapsibleGridId",
    path: "/CollapsibleGrid",
    exact: true,
    title: "CollapsibleGrid",
    component: CollapsibleGrid,
    hasParams: false,
    text: "CollapsibleGrid",
  },

  {
    id: "FinalMolGridPage",
    path: "/FinalMolGridPage",
    exact: true,
    title: "FinalMolGridPage",
    component: FinalMolGridPage,
    hasParams: false,
    securityKey: securityKey.MY_WORKSPACE,
    text: "FinalMolGridPage",
  },
];
